import { styled as o } from "styled-components";
import { Colors as r } from "../../styles/colors/index.js";
import { MediaQuery as e } from "../../styles/variables.js";
import { SmartLink as a } from "../SmartLink/index.js";
import { Caption as t, SmallHeavy as m } from "../../styles/typography/index.js";
import { Theme as i } from "../../styles/themes/index.js";
const g = o(a)`
  ${t}
  text-decoration: none;
  color: rgb(${r.Gray});

  &:hover {
    color: rgb(${i.colors.Alpha});
  }
`, x = o.div`
  display: flex;
  align-items: center;

  margin-bottom: 8px;
  @media ${e.SCREEN_MD_UP} {
    margin-bottom: 16px;
  }
`, f = o.span`
  ${m}

  display: flex;
  align-items: center;

  border-radius: 18px;
  padding: 0px 8px;
  margin-left: 8px;
  color: rgb(${r.Green});
  background-color: rgb(${i.colors.Delta});

  i {
    font-size: 16px;
  }

  @media ${e.SCREEN_MD_UP} {
    margin-left: 11px;
  }
`, S = o.div`
  ${t}
`;
export {
  g as StoreCaption,
  S as StoreCaptionSkeleton,
  f as StoreChecked,
  x as StoreWrapper
};
